import { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';

/**
 * react-router v6 removed the official <HistoryRouter>; this thin
 * shim lets us drive routing from our singleton history (so sagas
 * can navigate without component context).
 */
export function HistoryRouter({ history, children }) {
  const [state, setState] = useState({ action: history.action, location: history.location });
  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      navigationType={state.action}
      location={state.location}
      navigator={history}
    >
      {children}
    </Router>
  );
}
